module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/related/th/6-c4ce65adf32c8fe680b86a02b5053d78.jpg";